import { baseAPI } from 'api/base';
import isFetchBaseQueryError from 'api/baseError';

baseAPI.enhanceEndpoints({
	addTagTypes: ['usersCompany']
});

export const usersCompany = baseAPI.injectEndpoints({
	endpoints: builder => ({
		getAllUsersCompany: builder.query({
			query: () => ({
				url: `company/users`,
				method: 'GET',
				validateStatus: isFetchBaseQueryError
			}),
			providesTags: ['usersCompany']
		}),
		getAllUsersCompanyOnReassign: builder.query({
			query: () => ({
				url: `company/users/grouped`,
				method: 'GET',
				validateStatus: isFetchBaseQueryError
			}),
			providesTags: ['usersCompany']
		}),

		getFilteredUsersCompany: builder.mutation({
			query: body => ({
				url: `company/filtered`,
				method: 'Post',
				body,
				validateStatus: isFetchBaseQueryError
			})
		}),
		getUserCompany: builder.query({
			query: id => ({
				url: `company/${id}`,
				method: 'GET',
				validateStatus: isFetchBaseQueryError
			}),
			providesTags: ['usersCompany']
		}),

		addUserCompany: builder.mutation({
			query: body => ({
				url: `company/users`,
				method: 'POST',
				body,
				validateStatus: isFetchBaseQueryError
			}),
			providesTags: ['usersCompany']
		}),
		changeUserCompany: builder.mutation({
			query: body => ({
				url: `company/user_settings/change_company`,
				method: 'POST',
				body,
				validateStatus: isFetchBaseQueryError
			}),
			providesTags: ['usersCompany']
		})
	})
});

export const {
	useGetAllUsersCompanyQuery,
	useGetAllUsersCompanyOnReassignQuery,
	useAddUserCompanyMutation,
	useLazyGetUserCompanyQuery,
	useGetFilteredUsersCompanyMutation,
	useChangeUserCompanyMutation
} = usersCompany;
